var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "intl-phone-input allow-dropdown",
      on: { mouseleave: _vm.hideList },
    },
    [
      _c(
        "div",
        {
          staticClass: "flag-container",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggeList.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "selected-flag" }, [
            _c("div", { class: `iti-flag ${_vm.countryCode}` }),
            _vm._v(" "),
            _c("div", { class: `iti-arrow${_vm.isVisiblePanel ? " up" : ""}` }),
          ]),
          _vm._v(" "),
          _vm.isVisiblePanel
            ? _c(
                "ul",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.itemsData.frontItems, function (item) {
                    return _c(
                      "li",
                      {
                        class: `country${
                          item.code === _vm.countryCode ? " highlight" : ""
                        }`,
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.setCode(item.code)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "flag-box" }, [
                          _c("div", { class: `iti-flag ${item.code}` }),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "country-name" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dial-code" }, [
                          _vm._v("+" + _vm._s(item.dialCode)),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.itemsData.needSeparator
                    ? _c("li", { staticClass: "divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.itemsData.otherItems, function (item) {
                    return _c(
                      "li",
                      {
                        class: `country${
                          item.code === _vm.countryCode ? " highlight" : ""
                        }`,
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.setCode(item.code)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "flag-box" }, [
                          _c("div", { class: `iti-flag ${item.code}` }),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "country-name" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dial-code" }, [
                          _vm._v("+" + _vm._s(item.dialCode)),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "text",
          autocomplete: "off",
          name: _vm.name,
          placeholder: _vm.intlData.example,
        },
        domProps: { value: _vm.phone.number },
        on: { input: _vm.handleChangePhoneNumber, keyup: _vm.changeCountry },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }